(() => {
  const loader = document.currentScript || document.querySelector('[data-homepage-motion-loader]');
  const mobile = window.matchMedia('(max-width: 989px)');
  let loading = null;

  window.EdenEnsureHomepageMotion = () => {
    const baseStyles = document.querySelector('[data-homepage-base-css]');
    if (baseStyles) baseStyles.media = 'all';
    if (loading) return loading;
    const urls = [loader.dataset.gsap, loader.dataset.observer, loader.dataset.scroll];
    loading = Promise.all(urls.map(url => new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => reject(new Error('Homepage motion resource failed to load'));
      document.head.appendChild(script);
    }))).then(() => {
      document.dispatchEvent(new Event('eden:motion-ready'));
    }).catch(error => {
      loading = null;
      console.warn(error.message);
      throw error;
    });
    return loading;
  };

  const start = () => window.EdenEnsureHomepageMotion().catch(() => {});
  if (!mobile.matches || (window.Shopify && Shopify.designMode)) {
    start();
  } else {
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
      document.addEventListener(type, start, { once: true, passive: true });
    });
    mobile.addEventListener('change', event => { if (!event.matches) start(); });
  }
})();
